import { Link } from "react-router-dom";

import Button from "@mui/material/Button";

export type PropsType = {
    readonly to: string;
    readonly label?: string | JSX.Element;
    readonly variant?: "contained" | "outlined";
    readonly style?: React.CSSProperties;
    readonly onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    readonly state?: any;
};

function LinkButton({ variant = "contained", ...props }: PropsType) {
    return (
        <Button
            component={Link}
            to={props.to}
            variant={variant}
            style={props.style}
            color={"primary"}
            onClick={props.onClick}
            state={props.state}
        >
            {props.label}
        </Button>
    );
}

export default LinkButton;
